export default __webpack_public_path__ + "static/media/maze.db2d920f.svg";